import { useEffect, useState } from 'react';
import { globalPaymentDataSubscribe } from '@/api/tablet';
import { GlobalPayment } from '@/types/payment.type';

function useGlobalPaymentDataSubscribe(userId: string, tabletId: string) {
  const [paymentInfo, setPaymentInfo] = useState<GlobalPayment[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!userId) return;

    setIsLoading(true);

    const unsubscribe = globalPaymentDataSubscribe(
      userId,
      tabletId,
      (paymentInfo) => {
        setPaymentInfo(paymentInfo);
        setIsLoading(false);
      },
    );

    return () => {
      unsubscribe();
    };
  }, [userId, tabletId]);

  return { paymentInfo: paymentInfo[0], isLoading, error };
}

export default useGlobalPaymentDataSubscribe;
